// extracted by mini-css-extract-plugin
export default {"large-header":"LargeHeader_large-header__wT1Yp"};